import { ArrowLeftOutlined } from "@ant-design/icons";
import { FloatButton } from "antd";
import { useNavigate } from "react-router-dom";

export const BackbuttonComponent = ({ ...props }) => {
  const navigate = useNavigate();
  return (
    <FloatButton
      type="primary"
      icon={<ArrowLeftOutlined />}
      size={"middle"}
      onClick={() => navigate(-1)}
      {...props}
      style={{
        top: 68,
        right: "auto",
        marginBottom: 16,
      }}
    >
    </FloatButton>
  );
};
